import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

	public asgAdminUrl = environment.asgAdminUrl;
	public asgSecurityUrl = environment.asgSecurityUrl;
	private readonly notifier: NotifierService;
	forgotPasswordForm: FormGroup;
	Email: string = '';
	Password: string = '';
	errorMessage: string;
	hide: boolean = true;
	showSuccessMessage: boolean = false;
	public showHelpIcon: boolean = false;

	constructor(
		private router: Router,
		private login: LoginService,
		private fb: FormBuilder,
		private userService: UserService,
		private notifierService: NotifierService,
		private http: HttpClient,
	) {
		this.notifier = notifierService;
		this.forgotPasswordForm = fb.group({
			'email': [null, Validators.compose([Validators.required, Validators.email])]
		});
	}

	get f() { return this.forgotPasswordForm.controls }
	ngOnInit() {
	}

	public onFormSubmit(credentials) {
		this.notifier.notify('info', 'Processing...', '0');
		// console.log("login form submitted, authenticating...");
		this.login.forgotPassword(credentials.email).subscribe(data => {
			this.notifier.hide('0');
			this.notifier.notify('success', 'Success');
			this.showSuccessMessage = true;
		},
			error => {
				this.showSuccessMessage = true;
				this.notifier.hide('0');
				this.notifier.notify('success', 'Success');
				// if (error && error.status == 400) {
				// 	this.notifier.notify('error', 'Failed!  ' + error.error.message);
				// } else {
				// 	this.notifier.notify('error', 'Failed! Please try again later!');
				// }
			});
	}

	ShowHelpIcon() {
    if (!this.showHelpIcon) {
      this.showHelpIcon = true;
    }
  }
  ShowHelp() {
    if (!this.showHelpIcon) {
      this.showHelpIcon = true;
      this.login.setZendeskView(false);
    }
  }

   hasClass() {
    if (document.getElementById("myLauncher").classList.contains("help-icon")) {
      this.showHelpIcon = false;
    } else if (
      document
        .getElementById("myLauncher")
        .classList.contains("help-icon-click")
    ) {
      this.showHelpIcon = true;
    }
    return this.showHelpIcon;
  }

	public getEmailErrorMsg() {
		return this.forgotPasswordForm.get('email').hasError('required') ? 'You must enter a username' :
			this.forgotPasswordForm.get('email').hasError('email') ? 'Not a valid username' : '';
	}
}
